import React, { PureComponent } from 'react';
// utils
import T from 'prop-types';
import { toast } from 'react-toastify';
import { toastResponseErrors } from '../../../utils/response';
// shapes
import inputStep from '../../../shapes/inputStep';
// hoc
import { withFormik } from 'formik';
// components
import Form from '../../../components/Form/Form';
import CheckBox from '../../../components/CheckBox/CheckBox';
import FieldError from '../../../components/Form/FieldError';
import NavButton from './NavButton';
// styles
import styles from './QuizStep.mod.css';
import classnames from 'classnames/bind';
import StepTitle from './StepTitle';

const cn = classnames.bind(styles);

class QuizStep extends PureComponent {
  state = {
    isAnswered: false
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.error && nextProps.error) {
      toast.error('Please, ensure that at least one field is selected!');
    }
  }

  handlePrevButton = () => {
    const { isAnswered } = this.state;
    const { goPrevStep } = this.props;
    if (isAnswered) {
      this.setState({
        isAnswered: false
      });
    } else {
      goPrevStep();
    }
  };

  preSubmit = event => {
    const { setError, values } = this.props;
    const hasSelected = Object.keys(values).find(id => values[id]);

    event.preventDefault();

    if (hasSelected) {
      setError(null);
      this.setState({
        isAnswered: true
      });
    } else {
      setError('Please, select at least one answer!');
    }
  };

  render() {
    const {
      values,
      error,
      handleChange,
      handleSubmit,
      isSubmitting,
      activeStep,
      completedData,
      data: {
        description,
        content: { title, answers },
        id
      }
    } = this.props;

    const { isAnswered } = this.state;
    const key = completedData ? completedData.content_progress.id : id;
    return (
      <Form key={key} className={styles.container} onSubmit={handleSubmit}>
        <StepTitle title={title} description={description} />
        <div className={styles.quiz}>
          {answers.map((option, index) => (
            <div key={index} className={styles.checkBoxWrapper}>
              <CheckBox
                name={option.id}
                checked={values[option.id]}
                disabled={isAnswered}
                onChange={handleChange}
                label={option.title}
                className={cn(styles.checkBox, {
                  correct: isAnswered && option.is_correct,
                  wrong: isAnswered && !option.is_correct
                })}
                labelClassName={styles.label}
                boxClassName={styles.box}
                textLabelClassName={styles.textLabel}
              />
              {isAnswered &&
                option.is_correct && (
                  <p className={styles.answerDescription}>{option.content}</p>
                )}
            </div>
          ))}
          {error && <FieldError error={error} touched={true} />}
        </div>
        <div className={styles.navButtons}>
          {isAnswered ? (
            <NavButton direction="next" type="submit" disabled={isSubmitting}>
              Submit
            </NavButton>
          ) : (
            <NavButton direction="next" type="button" onClick={this.preSubmit}>
              Check
            </NavButton>
          )}
          {isAnswered && (
            <NavButton
              direction="prev"
              type="button"
              onClick={this.handlePrevButton}
            >
              Redo
            </NavButton>
          )}
          {!isAnswered &&
            activeStep && (
              <NavButton
                direction="prev"
                type="button"
                onClick={this.handlePrevButton}
              >
                Prev
              </NavButton>
            )}
        </div>
      </Form>
    );
  }
}

QuizStep.propTypes = {
  data: inputStep,
  activeStep: T.number.isRequired
};

const getDefaultValues = answers =>
  answers.reduce((obj, item) => {
    obj[item.id] = false;
    return obj;
  }, {});

const getValuesFromCompleted = ({ content_progress: { answer_progresses } }) =>
  answer_progresses.reduce((obj, item) => {
    obj[item.answer.id] = item.quiz_answer;
    return obj;
  }, {});

export default withFormik({
  enableReinitialize: true,
  mapPropsToValues: ({
    completedData,
    data: {
      content: { answers }
    }
  }) =>
    completedData
      ? getValuesFromCompleted(completedData)
      : getDefaultValues(answers),
  handleSubmit: (
    values,
    {
      setSubmitting,
      props: {
        data: { id },
        completedData,
        submitStep,
        updateStep,
        activeStep,
        stepsLength,
        history,
        setActiveStep
      }
    }
  ) => {
    const quiz_answers_data = [];
    Object.keys(values).map((key, index) => {
      quiz_answers_data[index] = {
        id: key,
        quiz_answer: values[key]
      };
      return null;
    });

    const resource = {
      step_id: id,
      quiz_answers_data
    };

    const onError = e => {
      setSubmitting(false);
      toastResponseErrors(e);
    };

    if (completedData) {
      updateStep({ resource, id: completedData.id })
        .then(() => {
          setSubmitting(false);
          activeStep === stepsLength - 1
            ? history.push('/dashboard')
            : setActiveStep(activeStep + 1);
        })
        .catch(onError);
    } else {
      submitStep(resource).catch(onError);
    }
  }
})(QuizStep);



// WEBPACK FOOTER //
// ./src/containers/Module/components/QuizStep.jsx